import React, { useState } from "react";
import PropTypes from "prop-types";
import { urlFor } from "../../sanityClient";
import FilteredVideoCarousel from "./FilteredVideoCarousel";

const ServiceItem = ({ service, isActive, onClick }) => (
  <div
    onClick={onClick}
    className={`sm:p-6 lg:py-12 xl:px-12 rounded-[20px] text-center cursor-pointer hover:bg-primary hover:text-black hover:-translate-y-1 duration-300 ${
      isActive ? "bg-primary text-black" : ""
    }`}
  >
    <img
      className="mx-auto mb-6 max-w-[150px]"
      src={urlFor(service.image.asset._ref).url()}
      width="120"
      alt={service.title}
    />
    <h4 className="font-medium text-2xl mb-4 hidden lg:block">
      {service.title}
    </h4>
    {/* <p className="opacity-80 hidden lg:block">{service.description}</p> */}
  </div>
);

ServiceItem.propTypes = {
  service: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const Services = ({ services, allVideos }) => {
  // Set first service as active by default
  const [activeServiceIndex, setActiveServiceIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const handleServiceClick = (index) => {
    if (index === activeServiceIndex) return; // Don't toggle off
    setIsLoading(true);
    setActiveServiceIndex(index);

    // Simulate loading delay
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  };

  // Map Arabic service titles to English categories
  const getCategoryFromServiceTitle = (serviceTitle) => {
    const titleLower = serviceTitle.toLowerCase();

    if (titleLower.includes("كتابة المحتوى") || titleLower.includes("محتوى")) {
      return "content creation";
    }
    if (titleLower.includes("التعليق الصوتي") || titleLower.includes("صوتي")) {
      return "voice acting";
    }
    if (titleLower.includes("تقديم الحفلات") || titleLower.includes("حفلات")) {
      return "parties";
    }

    if (titleLower.includes("content")) {
      return "content creation";
    }
    if (titleLower.includes("voice")) {
      return "voice acting";
    }
    if (titleLower.includes("parties")) {
      return "parties";
    }

    return "";
  };

  // Filter videos based on selected service
  const getFilteredVideos = () => {
    if (activeServiceIndex === null || !allVideos) return [];

    const selectedService = services.services[activeServiceIndex];
    const categoryToMatch = getCategoryFromServiceTitle(selectedService.title);

    return allVideos.filter((video) => {
      const videoCategory = video.category?.toLowerCase() || "";
      return videoCategory === categoryToMatch;
    });
  };

  return (
    <section
      className="ezy__service5 light py-14 md:py-24 bg-bg text-white"
      id="services"
    >
      <h2 className="text-3xl  leading-none text-center md:text-[45px] font-bold mb-6">
        {services.sectionTitle}
      </h2>
      <div className="container px-4">
        <div className="grid grid-cols-12 md:mb-12 text-start">
          <div className="col-span-12 lg:col-span-6">
            <p className="text-lg opacity-80 text-white">
              {services.sectionDescription}
            </p>
          </div>
        </div>

        <div className="bg-alt shadow-xl rounded-[30px] text-center p-4 lg:p-6 mt-12">
          <div className="grid grid-cols-12 gap-6">
            {services.services.map((service, i) => (
              <div className=" col-span-4" key={i}>
                <ServiceItem
                  service={service}
                  isActive={activeServiceIndex === i}
                  onClick={() => handleServiceClick(i)}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Show filtered videos */}
        {isLoading ? (
          <div className="mt-12 flex justify-center items-center p-12">
            <div className="loader"></div>
          </div>
        ) : (
          <FilteredVideoCarousel
            serviceCategory={services.services[activeServiceIndex].title}
            videos={getFilteredVideos()}
          />
        )}
      </div>
    </section>
  );
};

Services.propTypes = {
  services: PropTypes.object.isRequired,
  allVideos: PropTypes.array.isRequired,
};

export default Services;
